var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'flex-center': true,
    'full-width': _vm.fullWidth,
    'outlined': _vm.outlined,
    'focused': _vm.focused,
  },attrs:{"id":_vm.id,"type":_vm.type,"disabled":_vm.busy},on:{"click":_vm.handleClick}},[(_vm.busy)?[_c('base-animation',{attrs:{"name":"loading"}})]:[_vm._t("default"),_vm._v(_vm._s(_vm.label))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }